import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten, getCurrentDateForInput } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";

export default function DebtRegistrationForm({ studentUuid, callback, data }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState(0);
  const [dateDue, setDateDue] = useState(getCurrentDateForInput());


  async function init() {
    //run initializations here
    setReady(false);
    //..
    setReady(true);
  }

  function resetForm() {
    setTitle("");
    setDescription('');
    setAmount(0);
    setDateDue('');
  }

  async function create() {
    if(title && title.trim().length > 0) {
      if(!isNaN(Number(amount)) && Number(amount) > 0) {
        if(dateDue && dateDue.trim().length > 0) {
          
          setLoading(true);
          await callApi(
            'create-debt',
            {
              title,
              description,
              studentUuid,
              dateDue,
              amount,
              schoolUuid: appContext.currentSchoolUuid,
            }
          ).then(response => {
            if(response.status === 1) {
              if(callback) {
                callback();
              }
              appContext.tellMessage("Successful");
              resetForm()
            } else {
              appContext.tellError(response.msg)
            }
          })
          setLoading(false);
          
        } else {
          appContext.tellError("Invalid due date");
        }
      } else {
        appContext.tellError("Invalid amount");
      }
    } else {
      appContext.tellError("Invalid title");
    }

    
  }

  async function edit() {
    if(title && title.trim().length > 0) {
      if(!isNaN(Number(amount)) && Number(amount) > 0) {
        if(dateDue && dateDue.trim().length > 0) {
          
          setLoading(true);
          await callApi(
            'edit-debt',
            {
              uuid: data.uuid,
              title,
              description,
              dateDue,
              amount,
            }
          ).then(response => {
            if(response.status === 1) {
              if(callback) {
                callback();
              }
              appContext.tellMessage("Successful");
              resetForm()
            } else {
              appContext.tellError(response.msg)
            }
          })
          setLoading(false);
          
        } else {
          appContext.tellError("Invalid due date");
        }
      } else {
        appContext.tellError("Invalid amount");
      }
    } else {
      appContext.tellError("Invalid title");
    }

    
  }

  useEffect(() => {
    if(data) {
      setTitle(data.title);
      setDescription(data.description);
      setDateDue(data.dateDue);
      setAmount(data.amount);
    }
  }, [ data ])

  useEffect(() => {
    init();
  }, [])

  

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [ loading ])

  if (ready) {
    return (
    
      <div className="row">

        <div className="col-md-12 mt-2 mb-2">
          <label className="form-label">Debt Title</label>
          <input
            className="form-control"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </div>


        <div className="col-md-6 mt-2 mb-2">
          <label className="form-label">Amount Due in TZS</label>
          <input
            className="form-control"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </div>

        <div className="col-md-6 mt-2 mb-2">
          <label className="form-label">Due Date</label>
          <input
            className="form-control"
            value={dateDue}
            onChange={e => setDateDue(e.target.value)}
            type="date"
          />
        </div>

        <div className="col-md-12 mt-2 mb-2">
          <label className="form-label">Debt Description</label>
          <textarea
            className="form-control"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
          <div className="form-text">Optional</div>
        </div>

        <div className="col-md-12 mt-2 mb-2 text-end">
          <button
            className="btn btn-secondary"
            onClick={() => {
              if(data) {
                appContext.activateDialog({
                  message: `Edit this debt?`,
                  onConfirm: edit,
                })
              } else {
                appContext.activateDialog({
                  message: `Are you sure you want to record this debt?`,
                  onConfirm: create,
                })
              }
            }}
          >
            <MdCheck/> Submit
          </button>
        </div>
      </div>
                
    )
  } else {
    return (
      <div
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }


}